import { l as loadFonts } from './base.mjs';
import 'remotion';

const getInfo = () => ({
    "fontFamily": "Handlee",
    "importName": "Handlee",
    "version": "v14",
    "url": "https://fonts.googleapis.com/css2?family=Handlee:ital,wght@0,400",
    "unicodeRanges": {
        "latin": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    "fonts": {
        "normal": {
            "400": {
                "latin": "https://fonts.gstatic.com/s/handlee/v14/-F6xfjBsISg9aMakPm3wow.woff2"
            }
        }
    }
});
const fontFamily = getInfo().fontFamily;
const loadFont = (style, options) => {
    return loadFonts(getInfo(), style, options);
};

export { fontFamily, getInfo, loadFont };
